import {LOG_OUT, DEFAULT_AGENCY_PROFILE, STAFF_LIST_CORRECTION} from "./ActionTypes";

import StaffDataService from "../services/StaffDataService";
import AdminHomeService from "../services/AdminHomeService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});

// Set Staff List with pending correction count
const userList = (userListData) => ({type: STAFF_LIST_CORRECTION, userListData});

const defaultAgencyProfileData = (profileId, profile) => ({
    type: DEFAULT_AGENCY_PROFILE, profileId, profile
});


export const getUserList = (locationId, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = await StaffDataService.getUserList(locationId, allLocation);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(userList(result.data.user));
                return result.data.user;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDefaultAgencyProfile = (locationId) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getDefaultAgencyProfile(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                await dispatch(defaultAgencyProfileData(result.data.id, result.data));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const setDefaultAgencyProfile = (profileId, selectedAgencyProfile) => (
    async (dispatch) => {
        try {
            dispatch(defaultAgencyProfileData(profileId, selectedAgencyProfile));
        } catch (error) {
            console.log("set default agency profile - ", error);
        }
    }
);

export const getLoginStatus = (locationId, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getLoginStatus(locationId, allLocation);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            console.log(error);
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getActivityLogList = (locationId, page=1, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getActivityLogList(
                locationId, page, allLocation
            );

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    } 
); 

export const getUserActivityLogList = (logId) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getUserActivityLogList(logId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    } 
);

export const getUserRecognitionList = (locationId, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getUserRecognitionList(
                locationId, allLocation
            );

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
                return false;
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getPTORequestStatus = (locationId, allLocation=1) => (
    async (dispatch) => {
        try {
            let result = await AdminHomeService.getPTORequestStatus(
                locationId, allLocation
            );

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
                return false;
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/AdminHomeAction.js